import React, { useState, useEffect } from "react";

function QuestionForm({ question, onAnswer, canGoNext, setCanGoNext }) {
  const [selected, setSelected] = useState(null); // Valor seleccionado
  const [hasMovedSlider, setHasMovedSlider] = useState(false); // Para validar movimiento del slider

  useEffect(() => {
    setSelected(null);
    setHasMovedSlider(false);
  }, [question]); // Se ejecuta cuando cambia la pregunta

  useEffect(() => {
    if (question.type === "slider") {
      setCanGoNext(hasMovedSlider);
    } else if (question.type === "text") {
      setCanGoNext(selected && selected.trim().length > 0);
    } else if (question.type === "multiple" || question.type === "select") {
      setCanGoNext(selected && selected.length > 0);
    } else {
      setCanGoNext(true);
    }
  }, [selected, hasMovedSlider, question.type, setCanGoNext, question]);

  const handleSliderChange = (e) => {
    const value = parseInt(e.target.value, 10);
    setSelected(value);
    setHasMovedSlider(true);
    onAnswer(value);
  };

  const getLabelOpacity = (index) => {
    if (!question.sliderLabels || question.sliderLabels.length < 2) return 0;

    const step = 100 / (question.sliderLabels.length - 1);
    const labelPosition = step * index;

    const distance = Math.abs(selected - labelPosition);
    return distance <= step ? (1 - distance / step < 0.2 ? 0.2 : 1 - distance / step) : 0.2;
  };

  const handleChange = (value) => {
    if (question.type === "multiple") {
      const newSelection = (selected || []).includes(value)
        ? selected.filter((item) => item !== value)
        : [...(selected || []), value];
      setSelected(newSelection);
      onAnswer(newSelection);
    } else {
      setSelected(value);
      onAnswer(value);
    }
  };
  
  

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault(); // Evita la recarga de la página
    }
  };

  return (
    <form>
      {question.text && (
        <p className="question" dangerouslySetInnerHTML={{ __html: question.text }} />
      )}
      <div className="form-group">
        {question.type === "text" && (
          <input
            type="text"
            value={selected || ""}
            onChange={(e) => handleChange(e.target.value)}
            onKeyDown={handleKeyDown}
            className="form-control"
            placeholder="Escribe tu respuesta aquí..."
          />
        )}
        {(question.type === "select" || question.type === "multiple") && (
            <div className="styled-options-container">
              {question.options.map((option, index) => (
                <label key={index} className="styled-option">
                  <input
                    type={question.type === "multiple" ? "checkbox" : "radio"}
                    name="answer"
                    value={option}
                    checked={
                      question.type === "multiple"
                        ? selected && selected.includes(option)
                        : selected === option
                    }
                    onChange={() => handleChange(option)}
                  />
                  <span>{option}</span>
                </label>
              ))}
            </div>
          )}
        {question.type === "slider" && (
          <div style={{ width: "80%", margin: "auto" }}>
            <input
              type="range"
              min="0"
              max="100"
              value={selected || 50}
              onChange={handleSliderChange}
              className="range-slider"
              style={{
                background: "linear-gradient(to right, #ccc, #333)",
              }}
            />
            <div className="slider-labels">
              {question.sliderLabels &&
                question.sliderLabels.map((label, index) => (
                  <span
                    key={index}
                    style={{
                      display: "inline-block",
                      width: `${100 / question.sliderLabels.length}%`,
                      textAlign: "center",
                      opacity: getLabelOpacity(index),
                      color: "#333",
                      fontWeight: getLabelOpacity(index) > 0.5 ? "bold" : "normal",
                    }}
                  >
                    {label}
                  </span>
                ))}
            </div>
          </div>
        )}
      </div>
    </form>
  );
}

export default QuestionForm;
